import React, { useState, useRef, useCallback } from 'react';

const THRESHOLD = 80;

export default function PullToRefresh({ onRefresh, children }) {
  const [pulling, setPulling] = useState(false);
  const [pullDistance, setPullDistance] = useState(0);
  const [refreshing, setRefreshing] = useState(false);
  const startY = useRef(0);
  const containerRef = useRef(null);

  const handleTouchStart = useCallback((e) => {
    // Only trigger if scrolled to top
    if (window.scrollY > 5) return;
    startY.current = e.touches[0].clientY;
    setPulling(true);
  }, []);

  const handleTouchMove = useCallback((e) => {
    if (!pulling || refreshing) return;
    const diff = e.touches[0].clientY - startY.current;
    if (diff < 0) { setPullDistance(0); return; }
    setPullDistance(Math.min(diff * 0.5, 120));
  }, [pulling, refreshing]);

  const handleTouchEnd = useCallback(async () => {
    if (!pulling) return;
    if (pullDistance >= THRESHOLD && !refreshing) {
      setRefreshing(true);
      try { await onRefresh(); } catch (e) { console.error(e); }
      setRefreshing(false);
    }
    setPulling(false);
    setPullDistance(0);
  }, [pulling, pullDistance, refreshing, onRefresh]);

  return (
    <div
      ref={containerRef}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      style={{ position: 'relative' }}
    >
      {/* Pull indicator */}
      {(pullDistance > 10 || refreshing) && (
        <div style={{
          position: 'absolute', top: 0, left: 0, right: 0,
          display: 'flex', justifyContent: 'center', alignItems: 'center',
          height: refreshing ? 40 : pullDistance,
          overflow: 'hidden', transition: pulling ? 'none' : 'height 0.2s',
          zIndex: 10,
        }}>
          <div style={{
            fontSize: 12, fontWeight: 600,
            color: pullDistance >= THRESHOLD ? '#16A34A' : '#9CA3AF',
            display: 'flex', alignItems: 'center', gap: 6,
          }}>
            {refreshing ? (
              <><span style={{ animation: 'spin 1s linear infinite', display: 'inline-block' }}>↻</span> Actualisation…</>
            ) : pullDistance >= THRESHOLD ? (
              '↓ Relâche pour actualiser'
            ) : (
              '↓ Tire vers le bas…'
            )}
          </div>
        </div>
      )}

      {/* Content with offset */}
      <div style={{
        transform: `translateY(${refreshing ? 40 : pullDistance > 10 ? pullDistance : 0}px)`,
        transition: pulling ? 'none' : 'transform 0.2s',
      }}>
        {children}
      </div>

      <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
